import { gql } from "@apollo/client";

export const GET_SIGNED_UPLOAD_URL = gql`
  query Policy {
    s3PostPolicy {
      url
      fields {
        algorithm
        bucket
        credential
        date
        key
        policy
        securityToken
        signature
      }
    }
  }
`;
